<template>
    <div>
        <div id="uploadDocModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            Upload Word Document
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <file-pond
                            name="file"
                            ref="pond"
                            :server="server"
                            :onprocessfile="handleOnProcessFile"
                            allowRevert="false"
                            allowMultiple="false"
                            allowRemove="false"
                            class-name="my-pond"
                            dropOnElement="true"
                            dropOnPage="true"
                            label-idle="Drop or select a word document"
                            labelFileTypeNotAllowed="Invalid File Type"
                            fileValidateTypeLabelExpectedTypes="Only DOCX Documents Are Allowed."/>
                    </div>
                </div>
            </div>
        </div>
        <div id="editor-control-container" style="width:100%;height:150vh"></div>
        <div class="upload-doc-button" style="bottom: 60px;">
            <div class="snippetPopOverPGEditor">
                <snippets-popover></snippets-popover>
            </div>
        </div>
        <div class="proposal-overlay-content-save">
            <img src="/images/proposal-loader.gif" />
            <h1 class="align-center">{{ overlayText }}</h1>
        </div>
        <button type="button" @click="openUploadDocModal()" class="btn btn-primary upload-doc-button"><i class="fa fa-cloud-upload" aria-hidden="true"></i> Upload Word Document</button>
    </div>
</template>
<script>

import axios from "axios";
import SnippetsPopover from "./snippets-popover.vue";

export default {
    components: {SnippetsPopover},
    props: ['section', 'proposal', 'selectedProposalType', 'user', 'allCustomSignatures'],
    data() {
        return {
            documentId:null,
            sessionId:null,
            editor:null,
            prizmEditorBaseURL:null,
            overlayText:'',
            server: {
                process: (fieldName, file, metadata, load, error, progress) => {
                    let self = this;
                    const formData = new FormData();
                    let filename = file.name;
                    let extension = filename.match(/\.([^.]+)$/)[1];
                    formData.append('file', file, file.name);
                    formData.append('type', extension);
                    formData.append('sectionId', self.section.id);
                    const request = new XMLHttpRequest();
                    request.open('POST', route('prizm.upload-custom-doc'));
                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            load(request.responseText);
                            let response = JSON.parse(request.response);
                            self.documentURL = response.documentURL;
                            self.documentType = response.documentType;
                            self.docEditor.destroyEditor();
                            self.loadOnlyOfficeEditor();
                        } else {
                            error('Please try again.');
                        }
                    };
                    request.send(formData);
                }
            },
            docEditor: null,
            editorConnectors: null,
            onlyOfficeCallBackUrl: window.location.origin+"/only-office-callback/"+this.section.id+'/text',
            documentKey: null,
            documentURL: null,
            showEmbeddedHeaderFooter: this.section.show_embedded_header_footer,
            documentType: 'docx',
            formFieldCount: 0,
            customSignatureFields: [],
            customInitialFields: [],
            signatureInDoc: null,
            allSignerFields: this.allCustomSignatures,
        }
    },
    created() {
    },
    mounted() {
        this.prizmEditorBaseURL = process.env.MIX_PRIZM_EDITOR_URL;


        Bus.$on('savePrizmEditorDocumentBtn', data => {
            this.prizmEditorSave();
        });

        Bus.$on('saveContentEditor', data => {
            this.saveContent(data);
        });

        Bus.$on('selectContentToApply', data => {
            this.selectContent(data);
        });

        Bus.$on('updateContent', data => {
            this.updateContent(data);
        });

        Bus.$on('toolButtonDynamicField', data => {
            let content = { type: 'text', content: data['text'].replace(/\\n/g, "\n")};
            this.toolButtonForOnlyOfficeCustomFields(content);
        });

        Bus.$on('deselectPrizmDocContent', data => {
            $('#editor-control-container').empty();
            this.uploadPrizmEditorDocument();
        });
        Bus.$on('insertImageToPrizmEditor', data => {
            this.insertImage(data);
        });

        if(this.proposal.only_office == 'only-office'){
            this.getDocumentIdFromDB();
            Bus.$on('toolButton', data => {
                this.toolButtonForOnlyOffice(data['text']);
            });
            Bus.$on('insertImageToPrizmEditor', data => {
                this.insertImageToOnlyOffice(data);
            });
        }else{
            this.getDocumentIdFromDB();
            Bus.$on('toolButton', data => {
                this.editor.insertContent({ type:'text', content: '{{'+data['text']+'}} ' });
            });
        }
    },
    methods: {
        uploadPrizmEditorDocument(){
            let self = this;
            axios.post(route('prizm.upload-document'), {})
                .then((response) => {
                    self.documentId = response.data.response.documentId;
                    self.updateDocumentIdInSection();
                    self.createPrizmEditorSession();
                });
        },
        createPrizmEditorSession(){
            let self = this;
            this.$nextTick(()=>{
                axios.post(route('prizm.create-session'),{documentId:self.documentId})
                    .then((response) => {
                        self.sessionId = response.data.response.sessionId;
                        const nowDateTime = new Date();
                        const localStorageItem = {
                            sessionId: response.data.response.sessionId,
                            expiry: nowDateTime.getTime() + 3600000,
                        }
                        let sectionSessionId = 'section-session-id-'+self.section.id;
                        localStorage.setItem(sectionSessionId,JSON.stringify(localStorageItem));
                        this.$nextTick(()=>{
                            try {
                                self.createPrizmEditor();
                            }catch (error) {
                                self.createPrizmEditorSession();
                            }
                        });
                    });
            });
        },
        async createPrizmEditor(){
            Bus.$emit('applyFirstContent', true);
            $('#editor-control-container').empty();
            let self = this;
                const editor = await Accusoft.DocumentEditorControl.create({
                    baseUrl: self.prizmEditorBaseURL,
                    sessionId: self.sessionId,
                    container: document.getElementById('editor-control-container')
                });
                editor.on('saveStarted', () => {
                    Bus.$emit('savingPrizmDoc', 'Saving...');
                });
                editor.on('saveCompleted', () => {
                    Bus.$emit('savingPrizmDoc', 'Saved');
                });
                editor.on('saveFailed', () => {
                    Bus.$emit('savingPrizmDoc', 'Failed!');
                });
                self.editor = editor;

        },
        prizmEditorSave(){
            this.saveOnlyOfficeDocument('button');

        },
        updateDocumentIdInSection(){
            let self = this;
            this.$nextTick(()=>{
                axios.post(route('prizm.update-document-id-in-section'),{section:self.section,documentId:self.documentId})
                    .then((response) => {
                        self.sessionId = response.data.sessionId;
                        self.createPrizmEditor();
                    });
            });
        },
        getDocumentIdFromDB(){
            let self = this;
            if(this.proposal.only_office == 'only-office'){
                axios.post(route('proposal.only-office.get-document'),{sectionId:self.section.id}).then((response) => {
                    this.documentURL = response.data.documentURL;
                    this.documentType = response.data.documentType;
                    this.$nextTick(() => {
                       this.loadOnlyOfficeEditor();
                    });
                });
            }else{
                axios.post(route('prizm.get-document-id-of-section'),{section:self.section})
                    .then((response) => {
                        let sectionInfo = response.data.sectionDocumentId;
                        if(sectionInfo.document_id !== null){
                            self.documentId = sectionInfo.document_id;
                            let sectionSessionId = 'section-session-id-'+self.section.id;
                            if(!localStorage.getItem(sectionSessionId)){
                                self.createPrizmEditorSession();
                            }else{
                                const itemStr = localStorage.getItem(sectionSessionId);
                                const item = JSON.parse(itemStr);
                                const nowDateTime = new Date();
                                if (nowDateTime.getTime() > item.expiry) {
                                    localStorage.removeItem(sectionSessionId);
                                    self.createPrizmEditorSession();
                                }
                                axios.put(self.prizmEditorBaseURL+'api/v1/sessions/'+item.sessionId+'/active')
                                .then((response) => {
                                        self.sessionId = item.sessionId;
                                        self.createPrizmEditor();
                                })
                                .catch((error) => {
                                    self.createPrizmEditorSession();
                                });
                            }
                        }else{
                            self.uploadPrizmEditorDocument();
                        }
                    });
            }
        },
        saveContent(data){
            let self = this;
            $("#templateNameModal").modal("hide");
            self.overlayText = 'Saving Content'
            self.prizmEditorSave();
            $('.proposal-overlay-content-save').show();
            axios.post(route('prizm.save-content'),{section:self.section, sessionId:self.sessionId, contentGroup:data.content_group_id, templateName: data.template_name})
                .then((response) => {
                    $('.proposal-overlay-content-save').hide();
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    Bus.$emit('afterContentSaved', response.data);
                    Bus.$emit('enableSaveContentButton', true);
                });
        },
        selectContent(contentId){
            let self = this;
            self.overlayText = 'Applying Content'
            $('.proposal-overlay-content-save').show();
            axios.post(route('prizm.apply-content'),{section:self.section, sessionId:self.sessionId, contentId:contentId})
                .then((response) => {
                    self.documentURL = response.data.documentURL;
                    self.documentType = response.data.documentType;
                    self.showEmbeddedHeaderFooter = response.data.show_embedded_header_footer;
                    self.overlayText = '';
                    $('.proposal-overlay-content-save').hide();
                    $('#editor-control-container').empty();
                    // self.createPrizmEditorSession();
                    self.docEditor.destroyEditor();
                    self.loadOnlyOfficeEditor();
                    Bus.$emit('contentAppliedSuccessfully', response.data);
                    Bus.$emit('updateSectionForHeaderFooterImage', true);
                });
        },
        updateContent(contentId){
            let self = this;
            $("#templateNameModal").modal("hide");
            self.overlayText = 'Updating Content'
            // self.prizmEditorSave();
            self.saveOnlyOfficeDocument('content')
            $('.proposal-overlay-content-save').show();
            axios.post(route('prizm.update-content'),{contentId:contentId, sessionId:self.sessionId, section:self.section})
                .then((response) => {
                    $('.proposal-overlay-content-save').hide();
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                });
        },
        openUploadDocModal(){
            $('#uploadDocModal').modal("show");
        },
        handleOnProcessFile(){
            $('#uploadDocModal').modal("hide");
            $('#editor-control-container').empty();
            this.docEditor.destroyEditor();
            this.loadOnlyOfficeEditor();
        },
        insertImage(imageSrc){
            this.toDataUrl(imageSrc, (myBase64) => {
                const image = new Image();
                image.src = myBase64;
                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");
                image.onload = async() => this.imageToUint8Array(image, context, canvas);
            });
        },
        async imageToUint8Array(image, context, canvas) {
            canvas.width = image.width;
            canvas.height = image.height;
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(image, 0, 0, image.width, image.height, 0, 0, image.width, image.height);
            canvas.style.imageRendering = 'pixelated';
            this.tempImage = context;
            const blob = await this.toBlob(context.canvas, "image/jpeg");
            let imageData = new Uint8Array(await blob.arrayBuffer());
            console.log('inserting image');
            this.editor.insertContent({ type: 'image', content: imageData });
        },
        toBlob(canvas, type = "image/png", quality = 10) {
            return new Promise((resolve) => canvas.toBlob(blob => resolve(blob), 'image/jpeg', 1))
        },
        toDataUrl(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        },
        loadOnlyOfficeEditor(){
            let self = this;
            let documentKey = self.makeid(10);
            this.documentKey = documentKey;
            const config = {
                document: {
                    fileType: this.documentType,
                    key: documentKey,
                    title: "Title."+this.documentType,
                    url: this.documentURL,
                },
                documentType: "word",
                editorConfig: {
                    mode: "edit",
                    callbackUrl: this.onlyOfficeCallBackUrl,
                    coEditing: {
                        mode: 'fast',
                        change: true
                    },
                    customization: {
                        uiTheme: 'theme-followup',
                        customer: {
                            name: 'FollowupCRM',
                            logo: 'https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png'
                        },
                        forcesave: true,
                        logo: {
                            image: "https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png",
                            imageDark: "https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png",
                            url: "https://app.followupcrm.com/"
                        },
                        plugins: true,
                        unit: 'inch',
                        anonymous: {
                            request: false,
                            label: "Guest"
                        },
                        hideRightMenu: true,
                        review: {
                            hideReviewDisplay: true,
                            showReviewChanges: false
                        }
                    },
                },
                user: {
                    group: this.proposal.team_id,
                    id: this.user.id,
                    name: this.user.name,
                },
                height: "900px",
                type: "desktop",
                width: "100%",
                customization: {
                    anonymous: {
                        request: true,
                        label: "Guest"
                    },
                    autosave: true
                },
                events: {
                    'onDocumentReady': function(){
                        self.editorConnectors = self.docEditor.createConnector();
                        self.setPageSizeToUSLetter();
                        self.addHeaderAndFooterImage();
                        window.Asc.scope.customSignatureFields =[];
                        window.Asc.scope.customInitialFields =[];
                    },
                    'onDocumentStateChange': function(){
                        self.saveOnlyOfficeDocument(null);
                    }
                },
                permission: {
                    edit: true,
                    protect: false,
                    review: false
                }
            };
            this.docEditor = new DocsAPI.DocEditor("editor-control-container", config);
            this.$nextTick(() => {
                this.setEventsForOnlyOffice();
            });
        },
        setEventsForOnlyOffice(){
            this.editorConnectors = this.docEditor.createConnector();
        },
        makeid(length) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            return result;
        },
        toolButtonForOnlyOffice(text){

            let fieldCheck = false;
            if(/\bSignature\b/.test(text) || /\bInitials\b/.test(text)){
                if(this.signatureInDoc){
                    if(this.signatureInDoc.customSignatureFields){
                        if(this.signatureInDoc.customSignatureFields.length > 0){
                            this.signatureInDoc.customSignatureFields.forEach(item => {
                                if(text == 'Contact Signature' || text == 'My Signature'){
                                    if(item.name !== 'Contact Signature' && item.name !== 'My Signature' && item.name !== 'Contact Initials'){
                                        fieldCheck = true;
                                    }
                                }else{
                                    if(item.name == 'Contact Signature'){
                                        fieldCheck = true;
                                    }
                                    if(item.name == 'My Signature'){
                                        fieldCheck = true;
                                    }
                                    if(item.name == 'Contact Initials'){
                                        fieldCheck = true;
                                    }
                                }
                            })
                        }
                    }
                }
            }

            if(fieldCheck){
                this.getToast().fire({
                    type: 'error',
                    title: 'Custom signatures and contact signature field cannot be used together.'
                });
                return false;
            }

            let self = this;
            window.Asc.scope.text = '{{'+text+'}}';
            this.editorConnectors.callCommand(function(){
                var oDocument = Api.GetDocument();
                var oParagraph = Api.CreateParagraph();
                oParagraph.AddText(Asc.scope.text);
                oDocument.InsertContent([oParagraph]);
                Api.Save();
            }, function(){ console.log("callback command"); });
        },
        insertImageToOnlyOffice(imageSrc){
            this.docEditor.insertImage({
                c: "add",
                images: [
                    {
                        "fileType": "png",
                        "url": imageSrc
                    }
                ],
            });
        },
        async saveOnlyOfficeDocument(fromWhere){
            let self = this;
            this.$parent.savingPrizmDoc = 'Saving...';
            this.editorConnectors.executeMethod("GetAllForms", null, function (data) {
                if(data.length > 0){
                    self.formFieldCount = 1;
                }else{
                    self.formFieldCount = 0;
                }
            });

            await self.getAllSignerFields()
            this.$nextTick(() => {
                let self = this;
                window.Asc.scope.allCustomSignature =self.allSignerFields;
                console.log('===============================>>>>>>>>>>>>>>>>>>>',window.Asc.scope.allCustomSignature);
                this.editorConnectors.callCommand(function() {
                    var oDocument = Api.GetDocument();
                    function searchText(searchString) {
                        var found = false;
                        var paragraphs = oDocument.GetAllParagraphs();
                        for (var i = 0; i < paragraphs.length; i++) {
                            var paragraphText = paragraphs[i].GetText();
                            if (paragraphText.includes(searchString)) {
                                found = true;
                                break;
                            }
                        }
                        return found;
                    }

                    if (Asc.scope.allCustomSignature.length > 0){
                        Asc.scope.allCustomSignature.forEach(signature => {
                            var specificText = signature.name+" Signature";
                            var textFound = searchText(specificText);
                            if (textFound) {
                                Asc.scope.customSignatureFields.push({type: 'signature', name: signature.name, email: signature.email});
                                console.log(Asc.scope.customSignatureFields);
                            }
                            var specificInitials = signature.name+" Initials";
                            var initialFound = searchText(specificInitials);
                            if (initialFound) {
                                Asc.scope.customInitialFields.push({type: 'initial', name: signature.name, email: signature.email});
                            }
                        })
                    }

                    var specificText = "Contact Signature";
                    var textFound = searchText(specificText);
                    if (textFound) {
                        Asc.scope.customSignatureFields.push({type: 'signature', name: 'Contact Signature', email: ''});
                        console.log(Asc.scope.customSignatureFields);
                    }
                    var specificText = "My Signature";
                    var textFound = searchText(specificText);
                    if (textFound) {
                        Asc.scope.customSignatureFields.push({type: 'signature', name: 'My Signature', email: ''});
                    }

                    return {
                        customSignatureFields: Asc.scope.customSignatureFields,
                        customInitialFields: Asc.scope.customInitialFields,
                    };
                }, function(result) {
                    self.setCustomSignatureFieldsArray(result);
                });
            });


            axios.post(route('proposal.only-office.save-document'), {documentKey: this.documentKey, formFieldCount: this.formFieldCount, typeId: this.section.id, type: 'sectionDoc'})
                .then((response) => {
                    if(fromWhere){
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                    }
                    Bus.$emit('changeReviewButtonPrizm', true);
                    this.$parent.savingPrizmDoc = 'Saved';
                });
        },

        addHeaderAndFooterImage(){
            let self = this;
            if(!self.showEmbeddedHeaderFooter) {
                if (self.selectedProposalType.footer_image_show == 1 && self.selectedProposalType.footer_image_url) {
                    window.Asc.scope.footerUrl = self.selectedProposalType.footer_image_url;
                } else {
                    window.Asc.scope.footerUrl = 'null';
                }
                if (self.selectedProposalType.header_image_show == 1 && self.selectedProposalType.header_image_url) {
                    window.Asc.scope.headerUrl = self.selectedProposalType.header_image_url;
                } else {
                    window.Asc.scope.headerUrl = 'null';
                }

                self.editorConnectors.callCommand(function () {
                    var oDocument = Api.GetDocument();
                    var oParagraph = oDocument.GetElement(0);

                    var oSection = oDocument.GetFinalSection();
                    var pWidth = oSection.GetPageWidth();
                    var inches = pWidth / 1440;
                    var millimeters = inches * 25.4;

                    oSection.RemoveHeader("default");
                    oSection.RemoveFooter("default");
                    var oHeader = oSection.GetHeader("default", true);
                    var oFooter = oSection.GetFooter("default", true);

                    if (Asc.scope.headerUrl !== 'null') {
                        var oDrawingHeader = Api.CreateImage(Asc.scope.headerUrl, millimeters * 36000, 20 * 36000);
                        oDrawingHeader.SetWrappingStyle("behind");
                        oDrawingHeader.SetHorAlign("page", "left");
                        oDrawingHeader.SetVerAlign("page", "top");
                    }
                    if (Asc.scope.footerUrl !== 'null') {
                        var oDrawingFooter = Api.CreateImage(Asc.scope.footerUrl, millimeters * 36000, 20 * 36000);
                        oDrawingFooter.SetWrappingStyle("behind");
                        oDrawingFooter.SetHorAlign("page", "left");
                        oDrawingFooter.SetVerAlign("page", "bottom");
                    }

                    oParagraph = oHeader.GetElement(0);
                    oParagraph.AddDrawing(oDrawingHeader);

                    oParagraph = oFooter.GetElement(0);
                    oParagraph.AddDrawing(oDrawingFooter);


                }, function () {
                    console.log("callback command");
                });
            }
        },
        toolButtonForOnlyOfficeCustomFields(content){
            let fieldCheck = false;
            if(this.signatureInDoc){
                if(this.signatureInDoc.customSignatureFields){
                    if(this.signatureInDoc.customSignatureFields.length > 0){
                        this.signatureInDoc.customSignatureFields.forEach(item => {
                            if(content.content == 'Contact Signature' || content.content == 'My Signature'){
                                if(item.name !== 'Contact Signature' || item.name !== 'My Signature'){
                                    fieldCheck = true;
                                }
                            }else{
                                if(item.name == 'Contact Signature' || item.name == 'My Signature'){
                                    fieldCheck = true;
                                }
                            }
                        })
                    }
                }
            }

            if(fieldCheck){
                this.getToast().fire({
                    type: 'error',
                    title: 'Custom signatures and contact signature field cannot be used together.'
                });
                return false;
            }

            let self = this;
            window.Asc.scope.text = content.content;
            this.editorConnectors.callCommand(function(){
                var oDocument = Api.GetDocument();
                var oParagraph = Api.CreateParagraph();
                oParagraph.AddText(Asc.scope.text);
                oDocument.InsertContent([oParagraph]);
                Api.Save();
            }, function(){ console.log("callback command"); });
        },
        insertSnippet(data){
            this.editorConnectors.executeMethod("PasteHtml", [data]);
        },
        setPageSizeToUSLetter(){
            let self = this;
            self.editorConnectors.callCommand(function () {
                var oDocument = Api.GetDocument();
                var oSection = oDocument.GetFinalSection();
                oSection.SetPageSize(12240, 15840);
            }, function () {
                console.log("callback command");
            });
        },
        setCustomSignatureFieldsArray(result){
            this.customInitialFields = result.customInitialFields;
            this.customSignatureFields = result.customSignatureFields;
            this.signatureInDoc = {
                customInitialFields: result.customInitialFields,
                customSignatureFields: result.customSignatureFields
            };
            this.$nextTick(() => {
                this.saveSectionSignature();
            });
        },
        saveSectionSignature(fromWhere = null){
            axios.post(route('proposal.custom-signature.save-section'), {sectionId: this.section.id, customInitialFields: this.customInitialFields, customSignatureFields: this.customSignatureFields})
                .then((response) => {
                    this.signatureInDoc = response.data.proposalCustomSecton;
                    if(fromWhere){
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                    }
                    Bus.$emit('changeReviewButtonPrizm', true);
                    this.$parent.savingPrizmDoc = 'Saved';
                });
        },
        async getAllSignerFields(){
            axios.post(route('proposal-generator.get-all-signature-fields'), {proposalId: this.proposal.id, fromWhere: 'editor'}).then(response => {
                this.allSignerFields = response.data.allFields;
            });
        },
    },
    beforeDestroy() {
        Bus.$off('saveContentEditor');
        Bus.$off('selectContentToApply');
        Bus.$off('updateContent');
        Bus.$off('toolButton');
    },
}
</script>
<style lang="scss" escoped>
.proposal-overlay-content-save{
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top:18px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    cursor: pointer;
    background: #ffffffd9;
}
.proposal-overlay-content-save img{
    position: absolute;
    right: 42.5%;
    top: 18%;
}
.proposal-overlay-content-save h1{
    position: absolute;
    color: #01b1af;
    top: 50%;
    right: 42.5%;
    font-weight: 200;
}
.upload-doc-button{
    position: fixed;
    bottom: 10px;
    display: block;
    right: 18vw;
}
</style>
